(function () {
  const mq = window.matchMedia('(max-width: 767px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    const list = root.querySelector('.phy-blog-news-podcasts__list');
    const button = root.querySelector('.phy-blog-news-podcasts__show-more');
    if (!list || !button) return;

    const items = Array.from(root.querySelectorAll('.phy-blog-news-podcasts__item'));
    const visibleCount = parseInt(button.dataset.visibleCount, 10) || 1;

    if (items.length <= visibleCount) return;

    const hiddenItems = () => items.slice(visibleCount);

    function rescueFocus() {
      const active = document.activeElement;
      if (active && hiddenItems().some((el) => el.contains(active))) {
        button.focus();
      }
    }

    function collapsedHeight() {
      const last = items[visibleCount - 1];
      return last.getBoundingClientRect().bottom - list.getBoundingClientRect().top;
    }

    function forceReflow() {
      return list.offsetHeight;
    }

    let seq = 0;

    const DURATION = 350;

    function afterTransition(fn) {
      const token = seq;
      if (reduce.matches) {
        fn();
        return;
      }

      let done = false;
      let timer = null;

      const settle = () => {
        if (done || token !== seq) return;
        done = true;
        // eslint-disable-next-line no-use-before-define
        list.removeEventListener('transitionend', onEnd);
        clearTimeout(timer);
        fn();
      };

      const onEnd = (e) => {
        if (e.target !== list || e.propertyName !== 'max-height') return;
        settle();
      };

      timer = setTimeout(settle, DURATION + 50);
      list.addEventListener('transitionend', onEnd);
    }

    function collapse(animate) {
      seq += 1;
      if (animate) {
        list.style.maxHeight = `${list.scrollHeight}px`;
        forceReflow();
      }
      list.classList.add('js-collapsed');
      list.style.maxHeight = `${collapsedHeight()}px`;
      button.setAttribute('aria-expanded', 'false');
      button.textContent = button.dataset.labelMore;

      if (animate) {
        afterTransition(() => {
          rescueFocus();
          hiddenItems().forEach((el) => { el.inert = true; });
        });
      } else {
        rescueFocus();
        hiddenItems().forEach((el) => { el.inert = true; });
      }
    }

    function expand() {
      seq += 1;
      hiddenItems().forEach((el) => { el.inert = false; });
      list.style.maxHeight = `${list.scrollHeight}px`;
      button.setAttribute('aria-expanded', 'true');
      button.textContent = button.dataset.labelLess;

      afterTransition(() => {
        list.classList.remove('js-collapsed');
        list.style.maxHeight = '';
      });
    }

    function enable() {
      button.hidden = false;
      collapse(false);
    }

    function disable() {
      seq += 1;
      list.classList.remove('js-collapsed');
      list.style.maxHeight = '';
      items.forEach((el) => { el.inert = false; });
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.textContent = button.dataset.labelMore;
    }

    button.addEventListener('click', () => {
      if (button.getAttribute('aria-expanded') === 'true') {
        collapse(true);
      } else {
        expand();
      }
    });

    const onBreakpointChange = (e) => {
      if (e.matches) {
        enable();
      } else {
        disable();
      }
    };

    if (mq.matches) enable();

    if (mq.addEventListener) {
      mq.addEventListener('change', onBreakpointChange);
    } else if (mq.addListener) {
      mq.addListener(onBreakpointChange);
    }
  }

  document.querySelectorAll('.phy-blog-news-podcasts').forEach(init);
}());
